import ENV from "config/Env";
import { backendQueryKey, localQueryKey } from "hooks/useTypedQuery";

import type { DMSUser, Device, NetworkMetrics, OneiPlanningMonteur, PlanItPlanningMechanic, ROLES, User } from "models";
import type { USER_STATUSES } from "modules/UsersDashboard/hooks";

export type UsersResponseModel = {
  nb_items?: number;
  nb_pages?: number;
  users: User[];
};

export type UserRolesModel = {
  created_on: string;
  id: number;
  name: string;
  updated_on: string;
};

export type VersionsModel = {
  web_versions: string[];
  app_versions: string[];
  camera_versions: string[];
};

export type UsersDashboardFilter = {
  active_date_from: string | null;
  active_date_to: string | null;
  dealer_location_ids: number[];
  is_combi_user: boolean | null;
  is_dpo: boolean | null;
  mobile_versions: string[] | null;
  page: number;
  page_size: number;
  roles: ROLES[];
  status: USER_STATUSES;
  term: string;
  web_versions: string[] | null;
  dealer_ids: number[];
};

const component = "UsersDashboard";

export const UsersDashboardQueryKeys = {
  filters: localQueryKey<UsersDashboardFilter>({ component, data: "usersDashboardFilter" }),
  users: backendQueryKey<UsersResponseModel>({ component, baseUrl: ENV.systemBaseURL, endpoint: "/users/search" }),
  versions: backendQueryKey<VersionsModel>({ component, baseUrl: ENV.systemBaseURL, endpoint: "/users/versions/list" }),
  roles: backendQueryKey<UserRolesModel[]>({ component, baseUrl: ENV.authBaseURL, endpoint: "/acl/roles/list" }),
  dmsUsers: backendQueryKey<DMSUser[]>({ component, baseUrl: ENV.systemBaseURL, endpoint: "/users/dms/users/list" }),
  details: backendQueryKey<User>({ component, baseUrl: ENV.systemBaseURL, endpoint: "/users/details" }),
  devices: backendQueryKey<Device[]>({ component, baseUrl: ENV.systemBaseURL, endpoint: "/devices/find_by_user" }),
  metrics: backendQueryKey<NetworkMetrics[]>({ component, baseUrl: ENV.systemBaseURL, endpoint: "/support/list" }),
  planItMechanics: backendQueryKey<PlanItPlanningMechanic[]>({ component, baseUrl: ENV.systemBaseURL, endpoint: "/users/pairing/planit/list" }),
  oneIPlanningMechanics: backendQueryKey<OneiPlanningMonteur[]>({ component, baseUrl: ENV.systemBaseURL, endpoint: "/users/pairing/onei/list" }),
  assignedAppointmentsCount: backendQueryKey<number>({ component, baseUrl: ENV.appointmentBaseURL, endpoint: "/dayplanner/mechanics/assigned_count" })
};
